module.exports = __webpack_public_path__ + "img/peiyou.29727bf3.png";